import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  dates: {
    id: "home: air coverage gap dates",
    defaultMessage: "{startDate} to {endDate}",
  },
  datesOpen: {
    id: "home: air coverage gap dates open",
    defaultMessage: "{startDate} onwards",
  },
  complete: {
    id: "home: air coverage gap complete",
    defaultMessage: "Your statements cover the whole period. Confirm to continue.",
  },
  closedGap: {
    id: "home: air coverage gap closed",
    defaultMessage:
      "We haven't received any transactions for the period between {startDate} and {endDate}. Upload statements to continue.",
  },
  openGap: {
    id: "home: air coverage gap open",
    defaultMessage: "We're missing data from {date} onwards. Upload statements to continue.",
  },
  leadingGap: {
    id: "home: air coverage gap leading",
    defaultMessage: "We're missing data before {date}. Upload statements to continue.",
  },
  fragmentedIntro: {
    id: "home: air coverage gap fragmented intro",
    defaultMessage: "We're missing data for the following {count, plural, one {period} other {periods}}:",
  },
  fragmentedOutro: {
    id: "home: air coverage gap fragmented outro",
    defaultMessage: "Upload statements to continue.",
  },
});
